// extracted by mini-css-extract-plugin
export default {"root":"Auth_root__yxUGi","back":"Auth_back__qrkqy","title":"Auth_title__p-cKz","input":"Auth_input__Vnzri","button":"Auth_button__eEf3R","reset":"Auth_reset__YxP8T"};